import { apiRoot } from '../apiInstances';
export const ocrApi = {
  extractVin: async (attachment_id: number) => {
    const { data } = await apiRoot.post('/ocr/vin', { attachment_id });
    return data as { value: string; confidence: number; raw_response: string };
  },
  extractOdometer: async (attachment_id: number) => {
    const { data } = await apiRoot.post('/ocr/odometer', { attachment_id });
    return data as { value: string; units: 'mi' | 'km'; confidence: number; raw_response: string };
  },
};
